import { BeachPlanConfigurationType } from '../BeachPlanConfiguration/types/types'
import { GeneralConfigurationType } from '../GeneralConfiguration/types/types'
import { AvailabilityConfigurationType } from '../AvailabilityConfiguration/types/availability.types'
import { PricingConfigurationType } from '../PricingConfiguration/types/pricingConfiguration.types'
import { PaymentConfigurationType } from '../PaymentConfiguration/types/types'
import { EmailConfigurationType } from '../EmailConfiguration/types/emailConfiguration.types'

export const ConfigurationCategory = {
  BEACH_PLAN: 'beachPlan',
  GENERAL: 'general',
  AVAILABILITY: 'availability',
  PRICING: 'pricing',
  PAYMENT: 'payment',
  EMAIL: 'email',
} as const
export type ConfigurationType = (typeof ConfigurationCategory)[keyof typeof ConfigurationCategory]

//export type ConfigurationType = 'beachPlan' | 'general' | 'availability' | 'priceList' | 'payment'

export type ConfigurationData =
  | BeachPlanConfigurationType
  | GeneralConfigurationType
  | AvailabilityConfigurationType
  | PricingConfigurationType
  | PaymentConfigurationType
  | EmailConfigurationType
